/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packing_List_Extraction_Not_ReadyInputs */

const en_error_packing_list_extraction_not_ready = /** @type {(inputs: Error_Packing_List_Extraction_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The packing list cannot be sent to the extraction tool.`)
};

/**
* | output |
* | --- |
* | "The packing list cannot be sent to the extraction tool." |
*
* @param {Error_Packing_List_Extraction_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_packing_list_extraction_not_ready = /** @type {((inputs?: Error_Packing_List_Extraction_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packing_List_Extraction_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_packing_list_extraction_not_ready(inputs)
});